import { Injectable } from '@angular/core';
import { AppNotificationsService } from '@deltager/organizers/admin/core/services/app-notifications.service';
import { SpinnerOverlayService } from '@deltager/organizers/admin/shared/spinner-overlay/spinner-overlay.service';
import {
  BookingEventSetupUIActionTypes,
  BookingHideSpinnerAction,
  BookingShowNotificationAction,
  BookingShowSpinnerAction,
} from '@deltager/organizers/admin/modules/booking-event-setup/store/booking-event-setup.ui.actions';
import { AppNotificationType } from '@deltager/organizers/admin/shared/models/AppNotificationType';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BookingEventSetupUIEffects {
  constructor(
    private actions$: Actions,
    private appNotificationService: AppNotificationsService,
    private spinner: SpinnerOverlayService,
  ) {}

  showNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(BookingEventSetupUIActionTypes.ShowNotification),
        tap((action: BookingShowNotificationAction) => {
          const notificationMessage = action.payload.message;
          const notificationType = action.payload.notificationType;

          this.appNotificationService.sendNotification({
            type: notificationType ? notificationType : AppNotificationType.SUCCESS,
            message: notificationMessage,
          });
        }),
      );
    },
    { dispatch: false },
  );

  showSpinner$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(BookingEventSetupUIActionTypes.ShowSpinner),
        tap((action: BookingShowSpinnerAction) => {
          this.spinner.show();
        }),
      );
    },
    { dispatch: false },
  );

  hideSpinner$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(BookingEventSetupUIActionTypes.HideSpinner),
        tap((action: BookingHideSpinnerAction) => {
          this.spinner.hide();
        }),
      );
    },
    { dispatch: false },
  );
}
